module.exports = __webpack_public_path__ + "img/diagram-2.7b067d1b.svg";